import { useQuery } from '@tanstack/react-query';

import { ListVoucherLogsQuery, listVoucherLogs } from '~/services/PromoService';

type Params = {
  query?: ListVoucherLogsQuery;
};

export function useListVoucherLogs({ query }: Params) {
  return useQuery({
    queryKey: ['voucher-logs', query],
    queryFn: async () => {
      return await listVoucherLogs(query || {});
    },
  });
}
